export default __webpack_public_path__ + "static/media/brand-13.ff5c3229.png";